import { useState, useEffect } from 'react';
import { Envinronments } from '@/sidebar/domain/constants';
import { isEnabledByEnvAndSource } from '../services';

const sources = [
  'TT001',
  'TT007',
  'CNPJ2',
  'AF128',
  'AF223',
  'AF231',
  'AF336',
  'AF418',
  'AF699',
  'CN688',
  'CN888',
  'MF005',
];
const enviroments = [
  Envinronments.Development,
  Envinronments.Staging,
  Envinronments.Production,
];

export const useDashboardFlow = (
  source: string,
  currentEnvironment: Envinronments,
) => {
  const [isDashboardEnabled, setIsDashboardEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (!source) return;

    setIsDashboardEnabled(() =>
      isEnabledByEnvAndSource(source, enviroments, sources, currentEnvironment),
    );
  }, [source, currentEnvironment]);

  return { isDashboardEnabled };
};
